import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'

import request from '@/api/BaseApi'

import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'


Vue.prototype.$http = request


Vue.config.productionTip = false

Vue.use(VueTour)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
